import React from 'react';
import { labelcss } from 'app/modules/search-results-module/common/TabContainer';

export const SearchWarning = () => (
  <div css={labelcss}>Search keyword must be more than 3 characters</div>
);
